import { FaXTwitter } from "react-icons/fa6";
import { FaFacebookSquare, FaInstagram } from "react-icons/fa";
import { GrLinkedin } from "react-icons/gr";
import backgroundImg from "../../../assets/home/bg_trong_dong_new.png";
import { Check } from "lucide-react";
import { path } from "../../../utils/common/constant";
import { Link, useNavigate } from "react-router";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleNavigatePolicy = (policy: string) => {
    navigate("../" + path.POLICY, { state: { policy } });
  };

  return (
    <footer className="relative bg-primary-blue overflow-hidden">
      <div
        className="absolute -right-40 -top-40 w-[830px] h-[830px] opacity-60"
        style={{
          backgroundImage: `url(${backgroundImg})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat"
        }}
      />

      {/* Content Container */}
      <div className="relative flex flex-col justify-center items-center max-xl:px-10">
        <div className="mt-16 pb-10 border-t border-white/10 w-full"></div>

        <div className="w-full max-w-standard grid lg:grid-cols-2 grid-cols-1 gap-8">
          {/* E-Visa Section */}
          <div className="space-y-4 lg:w-[350px]">
            <h2 className="text-white md:text-2xl text-xl font-semibold">
              E-Visa
            </h2>
            <p className="text-white/80 max-md:text-sm">
              {t("footer.description")}
            </p>
            <div className="flex space-x-4">
              <a
                href="https://facebook.com"
                className="text-white hover:text-primary-lightyellow"
              >
                <FaFacebookSquare size={20} />
              </a>
              <a
                href="https://instagram.com"
                className="text-white hover:text-primary-lightyellow"
              >
                <FaInstagram size={20} />
              </a>
              <a
                href="https://x.com"
                className="text-white hover:text-primary-lightyellow"
              >
                <FaXTwitter size={20} />
              </a>
              <a
                href="https://linkedin.com"
                className="text-white hover:text-primary-lightyellow"
              >
                <GrLinkedin size={20} />
              </a>
            </div>
          </div>

          {/* Services and Policy Section */}
          <div className="flex gap-16 lg:-ml-32">
            {" "}
            {/* Services Section */}
            <div className="space-y-4">
              <h2 className="text-white md:text-2xl text-xl font-semibold">
                {t("footer.services")}
              </h2>
              <ul className="space-y-2 max-md:text-sm">
                <li>
                  <Link
                    to={path.OUR_SERVICES}
                    className="text-white/80 hover:text-primary-lightyellow flex items-center"
                  >
                    <Check className="text-primary-yellow mr-2" size={16} />
                    {t("footer.services.apply_visa")}
                  </Link>
                </li>
                <li>
                  <Link
                    to={path.OUR_SERVICES}
                    className="text-white/80 hover:text-primary-lightyellow flex items-center"
                  >
                    <Check className="text-primary-yellow mr-2" size={16} />
                    {t("footer.services.visa_requirements")}
                  </Link>
                </li>
                <li>
                  <Link
                    to={path.OUR_SERVICES}
                    className="text-white/80 hover:text-primary-lightyellow flex items-center"
                  >
                    <Check className="text-primary-yellow mr-2" size={16} />
                    {t("footer.services.visa_types")}
                  </Link>
                </li>
                <li>
                  <Link
                    to={path.OUR_SERVICES}
                    className="text-white/80 hover:text-primary-lightyellow flex items-center"
                  >
                    <Check className="text-primary-yellow mr-2" size={16} />
                    {t("footer.services.track_visa_status")}
                  </Link>
                </li>
              </ul>
            </div>
            {/* Policy Section */}
            <div className="space-y-4">
              <h2 className="text-white md:text-2xl text-xl font-semibold">
                {t("footer.policy")}
              </h2>
              <ul className="space-y-2 max-md:text-sm">
                <li>
                  <div
                    onClick={() => handleNavigatePolicy("1")}
                    className="text-white/80 hover:text-primary-lightyellow flex items-center cursor-pointer"
                  >
                    <Check className="text-primary-yellow mr-2" size={16} />
                    {t("footer.policy.general")}
                  </div>
                </li>
                <li>
                  <div
                    onClick={() => handleNavigatePolicy("2")}
                    className="text-white/80 hover:text-primary-lightyellow flex items-center cursor-pointer"
                  >
                    <Check className="text-primary-yellow mr-2" size={16} />
                    {t("footer.policy.information_security")}
                  </div>
                </li>
                <li>
                  <div
                    onClick={() => handleNavigatePolicy("3")}
                    className="text-white/80 hover:text-primary-lightyellow flex items-center cursor-pointer"
                  >
                    <Check className="text-primary-yellow mr-2" size={16} />
                    {t("footer.policy.complaint")}
                  </div>
                </li>
                <li>
                  <div
                    onClick={() => handleNavigatePolicy("4")}
                    className="text-white/80 hover:text-primary-lightyellow flex items-center cursor-pointer"
                  >
                    <Check className="text-primary-yellow mr-2" size={16} />
                    {t("footer.policy.payment")}
                  </div>
                </li>
                <li>
                  <div
                    onClick={() => handleNavigatePolicy("5")}
                    className="text-white/80 hover:text-primary-lightyellow flex items-center cursor-pointer"
                  >
                    <Check className="text-primary-yellow mr-2" size={16} />
                    {t("footer.policy.exchange_refund")}
                  </div>
                </li>
                {/* <li>
                  <div
                    onClick={() => handleNavigatePolicy("6")}
                    className="text-white/80 hover:text-primary-lightyellow flex items-center cursor-pointer"
                  >
                    <Check className="text-primary-yellow mr-2" size={16} />
                    {t("footer.policy.online_purchasing")}
                  </div>
                </li> */}
              </ul>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="mt-10 border-t border-white/10 w-full">
          <p className="text-center text-white/60 py-5">
            © E-Visa Platform {new Date().getFullYear()} |{" "}
            {t("footer.copyright")}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
